var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosecircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd761829-1841-4a35-bf90-ae06a5666726",
    "data-name": "b9c80198-d9d7-4e10-bf7d-c4a8525131e7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.9835 49.9548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0059,
    cy: 24.9489,
    r: 6.1578
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7522,49.3747,49.4034,3.7235A2.152,2.152,0,0,0,46.36.68L.7088,46.3312a2.152,2.152,0,0,0,3.0434,3.0435Z",
    transform: "translate(-0.05 -0.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.68,3.7235,46.3312,49.3747a2.1521,2.1521,0,0,0,3.0435-3.0435L3.7235.68A2.1521,2.1521,0,0,0,.68,3.7235Z",
    transform: "translate(-0.05 -0.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosecircle);
export default __webpack_public_path__ + "static/media/closecircle.d77fc500.svg";
export { ForwardRef as ReactComponent };